import React from "react";
import { css, styled } from "styled-components";

interface Props {
  inline?: boolean;
  small?: boolean;
  padTop?: boolean;
  className?: string;
}

const StyledSpinner = styled.div<{
  $inline?: boolean;
  $small?: boolean;
  $padTop?: boolean;
}>`
  /* top: 50px;
  position: relative; */
  padding-top: 10px;
  padding-bottom: 10px;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  &:before {
    content: "";
    box-sizing: border-box;
    /* position: absolute; */
    /* top: 15px;
    left: 50%; */
    width: 30px;
    height: 30px;
    display: block;
    margin: auto;
    /* margin-top: -15px;
    margin-left: -15px; */
    border-radius: 50%;
    border: 2px solid var(--dark600);
    border-top-color: inherit;
    animation: spinner 0.7s linear infinite;
  }

  ${(props) =>
    props.$inline &&
    css`
      position: static;
      position: relative;
      top: 5px;
    `}

  ${(props) =>
    props.$small &&
    css`
      padding: 0;

      &::before {
        width: 25px;
        height: 25px;
        border-top-color: $white;
      }
    `}

  ${(props) =>
    props.$padTop &&
    css`
      padding-top: 60px;
    `}
`;

const Spinner = (props: Props) => {
  const { inline, small, padTop, className } = props;
  return (
    <StyledSpinner
      $inline={inline}
      $small={small}
      $padTop={padTop}
      className={className}
    ></StyledSpinner>
  );
};

export default Spinner;
